module.exports = __webpack_public_path__ + "img/no_cerhead.c5be93a0.png";